export const getMapBoxToken = (): string => {
    return "pk.eyJ1IjoiaWNlLWpqYXNpbmVrLW1hcGJveCIsImEiOiJjbGV5cXJ0eGQwa2sxM3JvMHAzenFweXl4In0.3bGL116uGvpxKwEcXISrww";
}